import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, tap } from 'rxjs/operators';
import { LocationSector } from '../../interfaces/locations-sectors';
import { CREATE_LOCATION_SECTOR_MUTATION, GET_LOCATION_SECTOR_QUERY, SEARCH_LOCATION_SECTORS_QUERY, UPDATE_LOCATION_SECTOR_MUTATION } from './location-sectors.query';
import { CreateLocationSectorInput, SearchLocationSectorParams, SearchLocationSectorResult, UpdateLocationSectorInput } from './location-sectors.type';

@Injectable({
  providedIn: 'root',
})
export class LocationSectorApi {
  public constructor(private readonly apollo: Apollo) {}

  public async get(id: string): Promise<LocationSector | undefined> {
    return this.apollo.query<{ locationSector: LocationSector }>({
      query: GET_LOCATION_SECTOR_QUERY,
      variables: { id },
    })
    .pipe(map((response) => response.data && response.data.locationSector)).toPromise();
  }

  public async search(params?: SearchLocationSectorParams): Promise<SearchLocationSectorResult> {
    return this.apollo.query<{ locationSectors: SearchLocationSectorResult }>({
      query: SEARCH_LOCATION_SECTORS_QUERY,
      variables: params,
    }).pipe(map((response) => response.data && response.data.locationSectors)).toPromise();
  }

  public async create(params: CreateLocationSectorInput): Promise<LocationSector | undefined> {
    return this.apollo.mutate<{ createLocationSector: LocationSector }>({
      mutation: CREATE_LOCATION_SECTOR_MUTATION,
      variables: { input: params },
    }).pipe(map((response) => response.data && response.data.createLocationSector)).toPromise();
  }

  public async update(params: UpdateLocationSectorInput): Promise<LocationSector | undefined> {
    return this.apollo.mutate<{ updateLocationSector: LocationSector }>({
      mutation: UPDATE_LOCATION_SECTOR_MUTATION,
      variables: { input: params },
    }).pipe(map((response) => response.data && response.data.updateLocationSector)).toPromise();
  }

  public async archive(params: UpdateLocationSectorInput): Promise<LocationSector | undefined> {
    return this.apollo.mutate<{ updateLocationSector: LocationSector }>({
      mutation: UPDATE_LOCATION_SECTOR_MUTATION,
      variables: { input: params },
    }).pipe(map((response) => response.data && response.data.updateLocationSector)).toPromise();
  }

  public async unarchive(params: UpdateLocationSectorInput): Promise<LocationSector | undefined> {
    return this.apollo.mutate<{ updateLocationSector: LocationSector }>({
      mutation: UPDATE_LOCATION_SECTOR_MUTATION,
      variables: { input: params },
    }).pipe(map((response) => response.data && response.data.updateLocationSector)).toPromise();
  }

}
